
const createCountyProduct = (data: any) => ({
  ...data,
  price: 0,
  status: '재고있음',
  category: 'HYUNDAI COUNTY',
  colors: data.colors || ['#808080'],
  features: [
    { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환성' },
    { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    { icon: 'ri-star-line', title: '고품질', description: '내구성 보장' },
    { icon: 'ri-checkbox-circle-line', title: '품질 보증', description: '안심 사용' },
  ],
  craftStory: {
    image: `https://public.readdy.ai/ai/img_res/90d9aafa5f90b4e2cb9ebd506fbc2063.jpg${data.id}_craft&orientation=landscape`,
    story: `카운티의 ${data.description}입니다.`,
    details: ['순정 규격 제작', '고품질 소재', '내구성 보장', '완벽한 호환'],
  },
});

export const countyProducts = [
  createCountyProduct({
    id: 'COU001',
    name: 'COU001',
    subcategory: '램프',
    partNumber: '92101-5A100 L / 92102-5A100 R',
    description: 'HEAD LAMP',
    fullDescription:
      '현대 카운티 버스에 호환되는 헤드 램프입니다. 품번 92101-5A100 L / 92102-5A100 R. 좌우 구분 장착이 필요합니다.',
    compatibleVehicles: ['COUNTY'],
    voltage: '24V',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20County%20bus%20headlamp%20clear%20lens%20chrome%20housing%20rectangular%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting%20professional%20shot%20detailed&width=800&height=1000&seq=cou001main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=bus%20headlamp%20clear%20lens%20front%20view%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting%20detailed&width=800&height=1000&seq=cou001img1&orientation=portrait',
    ],
    colors: ['#C0C0C0'],
  }),
  createCountyProduct({
    id: 'COU002',
    name: 'COU002',
    subcategory: '램프',
    partNumber: '92201-58100 L / 92202-58100 R',
    description: 'FOG LAMP',
    fullDescription:
      '현대 카운티 버스에 호환되는 포그 램프입니다. 품번 92201-58100 L / 92202-58100 R. 좌우 구분 장착이 필요합니다.',
    compatibleVehicles: ['COUNTY'],
    voltage: '24V',
    image:
      'https://readdy.ai/api/search-image?query=bus%20fog%20lamp%20rectangular%20clear%20lens%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=1000&seq=cou002main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=rectangular%20fog%20light%20clear%20lens%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=1000&seq=cou002img1&orientation=portrait',
    ],
    colors: ['#FFFFFF'],
  }),
  createCountyProduct({
    id: 'COU003',
    name: 'COU003',
    subcategory: '램프',
    partNumber: '92302-58100',
    description: 'CORNER LAMP',
    fullDescription:
      '현대 카운티 버스에 호환되는 코너 램프입니다. 품번 92302-58100.',
    compatibleVehicles: ['COUNTY'],
    voltage: '24V',
    image:
      'https://readdy.ai/api/search-image?query=bus%20corner%20lamp%20clear%20amber%20lens%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=1000&seq=cou003main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=bus%20corner%20signal%20light%20clear%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=1000&seq=cou003img1&orientation=portrait',
    ],
    colors: ['#FFD700'],
  }),
  createCountyProduct({
    id: 'COU004',
    name: 'COU004',
    subcategory: '외장',
    partNumber: '86510-58000',
    description: 'BUMPER',
    fullDescription:
      '현대 카운티 버스에 호환되는 범퍼입니다. 품번 86510-58000.',
    compatibleVehicles: ['COUNTY'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=bus%20front%20bumper%20white%20heavy%20duty%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=1000&seq=cou004main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=white%20bus%20bumper%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=1000&seq=cou004img1&orientation=portrait',
    ],
    colors: ['#FFFFFF'],
  }),
  createCountyProduct({
    id: 'COU005',
    name: 'COU005',
    subcategory: '외장',
    partNumber: '86310-58000',
    description: 'GRILLE',
    fullDescription:
      '현대 카운티 버스에 호환되는 그릴입니다. 품번 86310-58000.',
    compatibleVehicles: ['COUNTY'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=bus%20front%20grille%20white%20plastic%20with%20horizontal%20slats%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=1000&seq=cou005main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=white%20bus%20grille%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=1000&seq=cou005img1&orientation=portrait',
    ],
    colors: ['#FFFFFF'],
  }),
  createCountyProduct({
    id: 'COU006',
    name: 'COU006',
    subcategory: '외장',
    partNumber: '71111-58000',
    description: 'HOOD',
    fullDescription:
      '현대 카운티 버스에 호환되는 후드입니다. 품번 71111-58000.',
    compatibleVehicles: ['COUNTY'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=bus%20engine%20hood%20black%20metal%20panel%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=1000&seq=cou006main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=bus%20hood%20black%20metal%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=1000&seq=cou006img1&orientation=portrait',
    ],
    colors: ['#000000'],
  }),
  createCountyProduct({
    id: 'COU007',
    name: 'COU007',
    subcategory: '외장',
    partNumber: '86330-58000 / 86340-58000',
    description: 'PANEL',
    fullDescription:
      '현대 카운티 버스에 호환되는 패널입니다. 품번 86330-58000 / 86340-58000.',
    compatibleVehicles: ['COUNTY'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=bus%20body%20panel%20gray%20plastic%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=1000&seq=cou007main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=bus%20panel%20gray%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=1000&seq=cou007img1&orientation=portrait',
    ],
  }),
  createCountyProduct({
    id: 'COU008',
    name: 'COU008',
    subcategory: '외장',
    partNumber: '86550-58000',
    description: 'GRILLE',
    fullDescription:
      '현대 카운티 버스에 호환되는 그릴입니다. 품번 86550-58000.',
    compatibleVehicles: ['COUNTY'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=bus%20front%20grille%20black%20plastic%20with%20horizontal%20slats%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=1000&seq=cou008main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=black%20bus%20grille%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=1000&seq=cou008img1&orientation=portrait',
    ],
    colors: ['#000000'],
  }),
  createCountyProduct({
    id: 'COU009',
    name: 'COU009',
    subcategory: '램프',
    partNumber: '92101-4A100 L / 92102-4A100 R',
    description: '1998 YEAR HEAD LAMP',
    fullDescription:
      '현대 카운티 1998년식 버스에 호환되는 헤드 램프입니다. 품번 92101-4A100 L / 92102-4A100 R.',
    compatibleVehicles: ['COUNTY', 'COUNTY 1998'],
    voltage: '24V',
    image:
      'https://readdy.ai/api/search-image?query=vintage%20bus%20headlamp%20clear%20lens%20chrome%20housing%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=1000&seq=cou009main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=classic%20bus%20headlight%20clear%20lens%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=1000&seq=cou009img1&orientation=portrait',
    ],
    colors: ['#C0C0C0'],
  }),
  createCountyProduct({
    id: 'COU010',
    name: 'COU010',
    subcategory: '램프',
    partNumber: '92401-5A100 L / 92402-5A100 R',
    description: 'REAR LAMP',
    fullDescription:
      '현대 카운티 버스에 호환되는 리어 램프입니다. 품번 92401-5A100 L / 92402-5A100 R.',
    compatibleVehicles: ['COUNTY'],
    voltage: '24V',
    image:
      'https://readdy.ai/api/search-image?query=bus%20rear%20tail%20lamp%20red%20amber%20clear%20triple%20lens%20combination%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=1000&seq=cou010main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=bus%20rear%20light%20red%20amber%20clear%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=1000&seq=cou010img1&orientation=portrait',
    ],
    colors: ['#FF0000'],
  }),
  createCountyProduct({
    id: 'COU011',
    name: 'COU011',
    subcategory: '램프',
    partNumber: '92305/06-8C320/8D320',
    description: 'SIDE LAMP',
    fullDescription:
      '현대 카운티 버스에 호환되는 사이드 램프입니다. 품번 92305/06-8C320/8D320.',
    compatibleVehicles: ['COUNTY'],
    voltage: '24V',
    image:
      'https://readdy.ai/api/search-image?query=bus%20side%20marker%20lamp%20amber%20orange%20small%20rectangular%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=1000&seq=cou011main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=amber%20side%20marker%20light%20small%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=1000&seq=cou011img1&orientation=portrait',
    ],
    colors: ['#FF8C00'],
  }),
  createCountyProduct({
    id: 'COU012',
    name: 'COU012',
    subcategory: '램프',
    partNumber: '92301/02-5A100',
    description: 'CORNER LAMP',
    fullDescription:
      '현대 카운티 버스에 호환되는 코너 램프입니다. 품번 92301/02-5A100.',
    compatibleVehicles: ['COUNTY'],
    voltage: '24V',
    image:
      'https://readdy.ai/api/search-image?query=bus%20corner%20lamp%20clear%20transparent%20lens%20pair%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=1000&seq=cou012main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=clear%20corner%20lamp%20pair%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=1000&seq=cou012img1&orientation=portrait',
    ],
    colors: ['#FFFFFF'],
  }),
  createCountyProduct({
    id: 'COU013',
    name: 'COU013',
    subcategory: '외장',
    partNumber: '86510-5A201',
    description: '1998 YEAR BUMPER',
    fullDescription:
      '현대 카운티 1998년식 버스에 호환되는 범퍼입니다. 품번 86510-5A201.',
    compatibleVehicles: ['COUNTY', 'COUNTY 1998'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=vintage%20bus%20front%20bumper%20white%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=1000&seq=cou013main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=white%20bus%20bumper%20vintage%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=1000&seq=cou013img1&orientation=portrait',
    ],
    colors: ['#FFFFFF'],
  }),
  createCountyProduct({
    id: 'COU014',
    name: 'COU014',
    subcategory: '외장',
    partNumber: '86611-5A101',
    description: '1999 YEAR BUMPER',
    fullDescription:
      '현대 카운티 1999년식 버스에 호환되는 범퍼입니다. 품번 86611-5A101.',
    compatibleVehicles: ['COUNTY', 'COUNTY 1999'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=bus%20front%20bumper%20gray%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=1000&seq=cou014main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=gray%20bus%20bumper%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=1000&seq=cou014img1&orientation=portrait',
    ],
  }),
];
